import { useState } from "react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Shield, X } from "lucide-react";
import { Link } from "wouter";

interface MfaNudgeProps {
  user: any;
}

export function MfaNudge({ user }: MfaNudgeProps) {
  const [dismissed, setDismissed] = useState(false);

  // Don't show if user has MFA enabled or if dismissed
  if (!user || user.mfaEnabled || dismissed) {
    return null;
  }

  return (
    <Alert className="border-orange-200 bg-orange-50 mb-4">
      <Shield className="h-4 w-4 text-orange-600 mt-2" />
      <div className="flex items-center justify-between w-full">
        <div className="flex-1">
          <AlertDescription className="text-orange-800">
            <span className="font-medium">Secure your account:</span> Enable
            Multi-Factor Authentication (MFA) to add an extra layer of security
            to your account.
          </AlertDescription>
        </div>
        <div className="flex items-center gap-2 ml-4">
          <Link href="/profile#mfa-section">
            <Button
              size="sm"
              className="bg-orange-600 hover:bg-orange-700 text-white"
            >
              Enable MFA
            </Button>
          </Link>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setDismissed(true)}
            className="text-orange-600 hover:text-orange-700 hover:bg-orange-100"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </Alert>
  );
}
